import React, { useState } from 'react';
import { FaCalendarAlt, FaUser, FaHome } from 'react-icons/fa';
import { dateService } from '../services/dateService';

const BookingWidget = () => {
    const [checkIn, setCheckIn] = useState('');
    const [checkOut, setCheckOut] = useState('');
    const [chalet, setChalet] = useState('Chalé Cristal');
    const [error, setError] = useState('');

    // Get today's date in YYYY-MM-DD format to prevent past dates
    const todayStr = new Date().toISOString().split('T')[0];

    const handleDateChange = (date, setDateFunc, isCheckIn) => {
        // Reset error when user interacts
        if (error) setError('');

        if (dateService.isDateBlocked(date)) {
            setError(`A data ${new Date(date).toLocaleDateString()} está indisponível.`);
            setDateFunc(''); // Limpa a seleção
        } else {
            setDateFunc(date);
        }
    };

    const handleBooking = (e) => {
        e.preventDefault();

        // Validation
        if (!checkIn || !checkOut) {
            setError('Por favor, selecione as datas de check-in e check-out.');
            return;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const checkInDate = new Date(checkIn + 'T00:00:00');
        const checkOutDate = new Date(checkOut + 'T00:00:00');

        if (checkInDate < today) {
            setError('A data de check-in não pode ser no passado.');
            return;
        }

        if (checkOutDate <= checkInDate) {
            setError('A data de check-out deve ser posterior à data de check-in.');
            return;
        }

        setError('');

        const phoneNumber = "5512988505805";
        // Hardcoded to 2 guests, removed price estimation
        const message = `Olá! Gostaria de verificar disponibilidade para o ${chalet} (2 pessoas). Check-in: ${checkIn}, Check-out: ${checkOut}.`;
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    return (
        <div className="booking-widget">
            <h2 className="booking-title">Reservar</h2>
            <form onSubmit={handleBooking} className="booking-form">
                {error && <div style={{ color: 'red', marginBottom: '10px', fontSize: '0.9em' }}>{error}</div>}

                <div className="booking-input-group">
                    <label htmlFor="chalet-select">
                        <FaHome />
                        <div>ESCOLHA O CHALÉ</div>
                    </label>
                    <select
                        id="chalet-select"
                        value={chalet}
                        onChange={(e) => setChalet(e.target.value)}
                    >
                        <option value="Chalé Cristal">Chalé Cristal</option>
                        <option value="Chalé Safira">Chalé Safira</option>
                    </select>
                </div>

                <div className="booking-row">
                    <div className="booking-input-group">
                        <label htmlFor="checkin-date">
                            <FaCalendarAlt />
                            <div>
                                CHECK-IN <small>a partir das 14h</small>
                            </div>
                        </label>
                        <input
                            id="checkin-date"
                            type="date"
                            min={todayStr}
                            value={checkIn}
                            onChange={(e) => handleDateChange(e.target.value, setCheckIn, true)}
                            required
                        />
                    </div>
                    <div className="booking-input-group">
                        <label htmlFor="checkout-date">
                            <FaCalendarAlt />
                            <div>
                                CHECK-OUT <small>até as 13h</small>
                            </div>
                        </label>
                        <input
                            id="checkout-date"
                            type="date"
                            min={checkIn || todayStr} // Check-out cannot be before check-in
                            value={checkOut}
                            onChange={(e) => handleDateChange(e.target.value, setCheckOut, false)}
                            required
                        />
                    </div>
                </div>

                <div className="guest-info-badge">
                    <FaUser />
                    <span>Máximo 2 hóspedes (Ideal para casais)</span>
                </div>

                {/* Price estimation removed as requested */}

                <button type="submit" className="booking-button">
                    Verificar Disponibilidade
                </button>
            </form>
        </div>
    );
};

export default BookingWidget;
